import studentsService from "../services/students.service";
import ACTION_TYPE from "./type.action";

export const getAllStudentsOfClass = (classId) => async (dispatch) => {
  const students = await studentsService.getStudents(classId);
  dispatch({
    type: ACTION_TYPE.GET_ALL_STUDENTS_OF_CLASS,
    payload: [...students],
  });
};


